import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon } from 'lucide-react';
const features = ['Más de 600 actividades adaptadas (1° a 6°)', 'BONUS 1: Kit de Regulación Emocional', 'BONUS 2: Tableros Visuales y Apoyos', 'BONUS 3: Atención, Memoria y Foco', 'BONUS 4: Cuaderno de Autonomía', 'BONUS 5: Planificador Docente Inclusivo', '4 BONUS PREMIUM: Juegos, Alimentación, Pausas y Matemática'];
export function PurchaseSection() {
  return <section id="compra" className="py-8 px-4 bg-black text-white text-center" data-id="element-103" data-mp="3a1kzbhk1qz98">
      <div className="max-w-5xl mx-auto" data-id="element-104" data-mp="354kv7c6rc6kr">
        <h2 className="text-[20px] font-black mb-2 text-[#F9327E]" data-id="element-105" data-mp="3jua8u6w1e31x">
          Accedé ahora al Megapack Inclusión Educativa
        </h2>

        <p className="text-lg md:text-xl font-medium mb-6 max-w-2xl mx-auto text-gray-300" data-id="element-106" data-mp="3ev601hd0y7c4">
          Pago único · Acceso de por vida.
        </p>

        <div className="relative flex flex-col rounded-3xl p-6 md:p-7 text-left shadow-2xl border-2 bg-gray-900 border-gray-800 max-w-md mx-auto" data-id="element-107" data-mp="3ostsu1r2l4rn">
          <span className="inline-block self-start text-[10px] md:text-xs font-black px-3 py-1 rounded-full mb-3 uppercase tracking-wide bg-gray-800 text-gray-300" data-id="element-108" data-mp="y76ftetilxh1">
            MEGAPACK INCLUSIÓN
          </span>

          <h3 className="text-2xl md:text-3xl font-black mb-1 text-white" data-id="element-109" data-mp="1758dbke1i7zk">
            Megapack Inclusión Educativa
          </h3>

          <ul className="space-y-2 mb-6 mt-2 flex-grow" data-id="element-110" data-mp="1h4phtyhk2fty">
            {features.map(f => <li key={f} className="flex items-start text-sm md:text-base" data-id="element-111" data-mp="1l6b42afzc6gt">
                <CheckIcon className="w-5 h-5 mr-2 flex-shrink-0 mt-0.5 text-green-500" data-id="element-112" data-mp="1l482qu9dmqws" />
                <span className="text-gray-200" data-id="element-113" data-mp="1pxt3uv69o107">{f}</span>
              </li>)}
          </ul>

          <div className="flex justify-center mb-4" data-id="element-114" data-mp="1uvcku2ucmrvu">
            <img src="https://cdn.magicpatterns.com/uploads/nQycAgud56za6mHCeuzmKT/mockup_pincipal.png" alt="Megapack Inclusión Educativa" className="w-auto max-h-44 object-contain drop-shadow-xl rounded-lg" data-id="element-115" data-mp="1zw076b7mukjq" />
          </div>

          <div className="mb-4" data-id="element-116" data-mp="1a7bm6wh1688t">
            <div className="flex items-center gap-2 mb-1" data-id="element-117" data-mp="1a84mbelhhzhz">
              <span className="text-lg font-bold line-through text-gray-500" data-id="element-118" data-mp="1ovpkqv7ezajk">
                ARS $39.990
              </span>
              <span className="bg-red-600 text-white text-xs font-black px-2.5 py-1 rounded-full" data-id="element-119" data-mp="1k4zj9t23zru5">
                50% OFF
              </span>
            </div>
            <span className="text-gray-400 text-sm font-bold align-top mr-1" data-id="element-120" data-mp="1sxkwyuqvv8c4">
              ARS
            </span>
            <span className="text-4xl md:text-5xl font-black text-white" data-id="element-121" data-mp="27ujzi46voazq">
              $19.990
            </span>
            <p className="text-xs mt-1 text-gray-400" data-id="element-122" data-mp="22vh5desfrp6j">
              Pago único · Acceso de por vida
            </p>
          </div>

          <CTAButton href="https://checkout.aula-mater.online/cart/44935969996845:1" className="w-full text-lg md:text-xl py-4" data-id="element-123" data-mp="dhcawu9hwvmj">
            👉 LO QUIERO
          </CTAButton>
        </div>

        <div className="max-w-md mx-auto mt-8" data-id="element-124" data-mp="2k7fdr3fb39a1">
          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1 text-sm font-bold text-gray-300" data-id="element-125" data-mp="2p34f9cavz08z">
            <span className="flex items-center" data-id="element-126" data-mp="2aeqfja8rnrwn">
              <span className="text-green-500 mr-1" data-id="element-127" data-mp="2fe335x7gp30a">✔</span> para 1° a 6° grado
            </span>
            <span className="flex items-center" data-id="element-128" data-mp="21etm6vbfm4v9">
              <span className="text-green-500 mr-1" data-id="element-129" data-mp="21d0dzbl67cl5">✔</span> acceso inmediato
            </span>
            <span className="flex items-center" data-id="element-130" data-mp="25gyg7v5sl3if">
              <span className="text-green-500 mr-1" data-id="element-131" data-mp="1rgnkoetjf0qx">✔</span> descarga digital
            </span>
          </div>
        </div>
      </div>
    </section>;
}